import React, { memo, FC, useEffect } from "react"
import { Appearance, ScrollView } from "react-native"
import { observer } from "mobx-react-lite"
import { useStores } from "../../models"
import autoFeederWalkthrough from "../../guides/auto-feeder-walkthrough"
import { exitWalkthrough, startWalkthrough } from "react-native-walkthrough"
import { useIsFocused } from "@react-navigation/native"

export interface AstoModalProps {
  colorScheme?: "light"|"dark"
  scrollViewRef?: { current: ScrollView }
}

export const AstoModal: FC<AstoModalProps> = memo(observer(function AstoModal(props) {
  const { scrollViewRef } = props;
  const { userStore } = useStores()
  const isFocused = useIsFocused()

  useEffect(() => {
    startWalkthrough(autoFeederWalkthrough(() => {
      userStore.updateData({ state: { asto_coachmark_shown: true } }).finally(() => userStore.getUser())
      if (scrollViewRef && scrollViewRef.current)
        scrollViewRef.current.scrollTo({ y: 0 })
    }))
  }, [scrollViewRef, userStore])

  useEffect(() => {
    return () => {
      if (isFocused) exitWalkthrough()
    }
  }, [isFocused])

  return null
}))

export interface OnboardAstoModalProps {
  colorScheme?: "light"|"dark"
  scrollViewRef?: { current: ScrollView }
}

/**
 * Describe your component here
 */
export const OnboardAstoModal = memo(observer(function OnboardModal(props: OnboardAstoModalProps) {
  const { colorScheme = "light" || Appearance.getColorScheme(), scrollViewRef } = props;
  const { userStore: { user } } = useStores()
  const { state = {} } = user || {}
  if (!user) return null;
  if (!state.asto_coachmark_shown)
    return <AstoModal
      colorScheme={colorScheme}
      scrollViewRef={scrollViewRef}
    />;

  return null;
}))
